"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _debug = _interopRequireDefault(require("debug"));
var _Spinner = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Spinner"));
var _TextField = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/TextField"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _reactRedux = require("react-redux");
var _exchangeUiPortalsStore = require("@mulesoft/exchange-ui-portals-store");
var _hooks = require("./hooks");
var _events = require("../../analytics/events");
var _Pages = _interopRequireDefault(require("./Pages"));
var _Actions = _interopRequireDefault(require("./Actions"));
var _utils = require("./utils");
var _SearchContext = require("./SearchContext");
var _reducer = require("./reducer");
var _CustomResults = _interopRequireDefault(require("./CustomResults"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var styles = {
  "textfield": "Search__textfield__eEBtu",
  "spinner": "Search__spinner__7fqi1",
  "section": "Search__section__uLwp9",
  "section-title": "Search__section-title__2ggW5",
  "sectionTitle": "Search__section-title__2ggW5",
  "empty-results": "Search__empty-results__2FbsH",
  "emptyResults": "Search__empty-results__2FbsH",
  "search-section": "Search__search-section__290Ln",
  "searchSection": "Search__search-section__290Ln",
  "tabs": "Search__tabs__1k5mF",
  "results": "Search__results__14W9x"
}; 
require('./Search.css');
var log = (0, _debug.default)('exchange:search:component');
var SEARCH_MAX_LENGTH = 60;
var SEARCH_DELAY = 300;
var HIGHLIGHT_DELAY = 200;
var DOCUMENTATION_NODE_TEST_ID_SELECTOR = '[data-test-id="asset-content"]';
var SEARCH_TERM_MIN_LENGTH = 3;
var stateInitialValues = {
  term: '',
  loading: false,
  resultPaths: [],
  pageMatches: [],
  customMatches: [],
  startFromFirstMatch: true,
  highlightedElements: [],
  emptyResults: false
};
var Search = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var asset = _ref.asset,
    disabled = _ref.disabled,
    onClose = _ref.onClose;
  var _useReducer = (0, _react.useReducer)(_reducer.reducer, stateInitialValues),
    _useReducer2 = (0, _slicedToArray2.default)(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  var store = (0, _reactRedux.useStore)();
  var pagesRef = (0, _react.useRef)();
  var customMatchesRef = (0, _react.useRef)();
  var fetch = (0, _exchangeReactHooks.useFetch)();
  var getPortalPath = (0, _exchangeReactHooks.useGetPortalPath)();
  var isCurrentPath = (0, _hooks.useIsCurrentPath)();
  var push = (0, _exchangeReactHooks.usePush)();
  var config = (0, _exchangeReactHooks.useConfig)();
  var tryFn = (0, _exchangeReactHooks.useTryFn)();
  var _React$useContext = _react.default.useContext(_exchangeReactHooks.AssetPortalContext),
    searchDefinition = _React$useContext.search;
  var trackEvent = (0, _exchangeReactHooks.useAnalyticsTracking)();
  var isPortalLoading = (0, _reactRedux.useSelector)(_exchangeUiPortalsStore.selectors.selectIsPortalLoading);
  var searchConfiguration = typeof searchDefinition === 'function' ? searchDefinition() // this one will work as a hook
  : searchDefinition;
  var term = state.term,
    loading = state.loading,
    pageMatches = state.pageMatches,
    customMatches = state.customMatches,
    currentResultPath = state.currentResultPath,
    currentMatch = state.currentMatch,
    currentTotalMatches = state.currentTotalMatches,
    highlightedElements = state.highlightedElements,
    emptyResults = state.emptyResults,
    resultPaths = state.resultPaths;

  // this will be used to handle shortcuts in the search textfield
  var inputRef = (0, _react.useRef)();
  var setInputRef = (0, _react.useCallback)(function (innerRef) {
    inputRef.current = innerRef;
  }, []);
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      focus: function focus() {
        var _inputRef$current, _inputRef$current2, _inputRef$current2$se;
        (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.focus();
        (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 || (_inputRef$current2$se = _inputRef$current2.select) === null || _inputRef$current2$se === void 0 || _inputRef$current2$se.call(_inputRef$current2);
      }
    };
  }, []);
  var pagesFromStore = (0, _reactRedux.useSelector)(function (reduxState) {
    return _exchangeUiPortalsStore.selectors.selectPages(reduxState, {
      groupId: asset.groupId,
      assetId: asset.assetId,
      version: asset.version,
      isDraft: false
    });
  });
  var termRef = _react.default.useRef();
  _react.default.useEffect(function () {
    termRef.current = term;
    return function () {
      termRef.current = undefined;
    };
  }, [term]);
  var debouncedHighlight = (0, _hooks.useDebounce)(function (container) {
    dispatch({
      type: 'HIGHLIGHT_MATCHES',
      data: {
        container: container,
        isCurrentPath: isCurrentPath
      }
    });
  }, HIGHLIGHT_DELAY);

  /**
   * Highlight content on page navigation
   */
  (0, _react.useEffect)(function () {
    var _global$document$quer, _global$document;
    log('highlight content effect');
    var container = (_global$document$quer = (_global$document = global.document) === null || _global$document === void 0 ? void 0 : _global$document.querySelector(DOCUMENTATION_NODE_TEST_ID_SELECTOR)) !== null && _global$document$quer !== void 0 ? _global$document$quer : null;
    if (container && !disabled && !isPortalLoading && currentResultPath && term.length >= SEARCH_TERM_MIN_LENGTH) {
      log('running debounced highlight fn');
      debouncedHighlight(container);
    }
    if (disabled) {
      log('clearing results');
      dispatch({
        type: 'CLEAN_RESULTS'
      });
    }
    return function () {
      log('clearing debounced highlight');

      // Discard pending higlighting
      debouncedHighlight.clear();
    };
  }, [isPortalLoading, currentResultPath, disabled, debouncedHighlight, term]);

  /**
   * Navigate to path when the next match is in another page
   */
  (0, _react.useEffect)(function () {
    log('navigate path effect');
    if (currentResultPath && !isCurrentPath(currentResultPath)) {
      var path = getPortalPath(currentResultPath);
      log('pushing new path', path);
      push(path);
    }
  }, [currentResultPath]);

  /**
   * Clean previous highlighted terms
   */
  (0, _react.useEffect)(function () {
    return function () {
      log('cleaning wrapped elements', highlightedElements);
      (0, _utils.cleanWrappedElements)(highlightedElements);
    };
  }, [highlightedElements]);
  var search = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee2(searchTerm) {
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            tryFn(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee() {
              var matches, searchResponse, _yield$searchResponse, pages, _matches$pageMatches, _matches$customMatche;
              return _regenerator.default.wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    dispatch({
                      type: 'SEARCH_STARTED'
                    });
                    matches = {
                      pageMatches: [],
                      customMatches: []
                    }; // Find matches in the documentation pages
                    _context.next = 4;
                    return fetch("/api/v2/assets/".concat(asset.groupId, "/").concat(asset.assetId, "/minorVersions/").concat(asset.minorVersion, "/portal/search/?term=").concat(encodeURIComponent(searchTerm)));
                  case 4:
                    searchResponse = _context.sent;
                    _context.next = 7;
                    return searchResponse.json();
                  case 7:
                    _yield$searchResponse = _context.sent;
                    pages = _yield$searchResponse.pages;
                    matches.pageMatches = (0, _utils.getUniquePageMatches)(pages, pagesFromStore);
                    if (!(searchConfiguration !== null && searchConfiguration !== void 0 && searchConfiguration.onSearch)) {
                      _context.next = 14;
                      break;
                    }
                    _context.next = 13;
                    return searchConfiguration.onSearch({
                      asset: asset,
                      config: config,
                      state: store.getState(),
                      term: searchTerm
                    });
                  case 13:
                    matches.customMatches = _context.sent;
                  case 14:
                    // this validates that the search term used to execute this query remains the same in the text field
                    if (termRef.current === searchTerm) {
                      dispatch({
                        type: 'SEARCH_FINISHED',
                        data: _objectSpread(_objectSpread({}, matches), {}, {
                          pagesFromStore: pagesFromStore,
                          isCurrentPath: isCurrentPath
                        })
                      });
                      trackEvent(_events.EVENT_TYPES.SEARCHED_IN_PORTAL, _objectSpread(_objectSpread({
                        term: searchTerm
                      }, (0, _events.assetProperties)({
                        asset: asset
                      })), {}, {
                        resultsCount: {
                          pages: (_matches$pageMatches = matches.pageMatches) === null || _matches$pageMatches === void 0 ? void 0 : _matches$pageMatches.length,
                          custom: (_matches$customMatche = matches.customMatches) === null || _matches$customMatche === void 0 ? void 0 : _matches$customMatche.length
                        }
                      }));
                    }
                  case 15:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            })));
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [asset === null || asset === void 0 ? void 0 : asset.assetId, asset === null || asset === void 0 ? void 0 : asset.groupId, asset === null || asset === void 0 ? void 0 : asset.minorVersion, fetch, pagesFromStore, isCurrentPath, tryFn]);
  var debouncedSearch = (0, _hooks.useDebounce)(search, SEARCH_DELAY);
  var handleChange = (0, _react.useCallback)(function (_ref4) {
    var value = _ref4.value;
    log('handling change ', value);
    dispatch({
      type: 'SEARCH_TERM_CHANGED',
      term: value
    });
    if (value.length >= SEARCH_TERM_MIN_LENGTH) {
      log('executing debounced search');
      debouncedSearch(value);
    } else {
      log('cancelling search');
      dispatch({
        type: 'SEARCH_STOPPED'
      });
      debouncedSearch.clear();
    }
  }, [debouncedSearch]);
  var handleNextMatch = function handleNextMatch() {
    log('moving to next match');
    if (resultPaths.length) {
      dispatch({
        type: 'MOVE_TO_MATCH',
        direction: _reducer.Direction.Next
      });
      trackEvent(_events.EVENT_TYPES.NAVIGATED_PORTAL_SEARCH_MATCHES, _objectSpread({
        searchType: 'actionArrows'
      }, (0, _events.assetProperties)({
        asset: asset
      })));
    }
  };
  var handleNextMatchShortcut = function handleNextMatchShortcut(event) {
    var _event$preventDefault;
    if (disabled) {
      return;
    }
    (_event$preventDefault = event.preventDefault) === null || _event$preventDefault === void 0 || _event$preventDefault.call(event);
    log('moving to next match');
    if (resultPaths.length) {
      dispatch({
        type: 'MOVE_TO_MATCH',
        direction: _reducer.Direction.Next
      });
      trackEvent(_events.EVENT_TYPES.NAVIGATED_PORTAL_SEARCH_MATCHES, _objectSpread({
        searchType: 'shortcut'
      }, (0, _events.assetProperties)({
        asset: asset
      })));
    }
  };
  var handlePrevMatch = function handlePrevMatch() {
    log('moving to previous match');
    if (resultPaths.length) {
      dispatch({
        type: 'MOVE_TO_MATCH',
        direction: _reducer.Direction.Previous
      });
      trackEvent(_events.EVENT_TYPES.NAVIGATED_PORTAL_SEARCH_MATCHES, _objectSpread({
        searchType: 'actionArrows'
      }, (0, _events.assetProperties)({
        asset: asset
      })));
    }
  };
  var handlePrevMatchShortcut = function handlePrevMatchShortcut(event) {
    var _event$preventDefault2;
    if (disabled) {
      return;
    }
    (_event$preventDefault2 = event.preventDefault) === null || _event$preventDefault2 === void 0 || _event$preventDefault2.call(event);
    log('moving to previous match');
    if (resultPaths.length) {
      dispatch({
        type: 'MOVE_TO_MATCH',
        direction: _reducer.Direction.Previous
      });
      trackEvent(_events.EVENT_TYPES.NAVIGATED_PORTAL_SEARCH_MATCHES, _objectSpread({
        searchType: 'shortcut'
      }, (0, _events.assetProperties)({
        asset: asset
      })));
    }
  };
  var handleClick = (0, _react.useCallback)(function (_ref5) {
    var path = _ref5.path;
    log('handling click result');
    dispatch({
      type: 'RESULT_CLICKED',
      path: path
    });
    trackEvent(_events.EVENT_TYPES.NAVIGATED_PORTAL_SEARCH_MATCHES, _objectSpread({
      searchType: 'click'
    }, (0, _events.assetProperties)({
      asset: asset
    })));
  }, []);
  var searchContextValue = (0, _react.useMemo)(function () {
    return {
      currentMatch: currentMatch,
      currentTotalMatches: currentTotalMatches,
      onNavigate: handleClick
    };
  }, [currentMatch, currentTotalMatches, handleClick]);
  var handleTextFieldKeyDown = (0, _react.useCallback)(function (event) {
    var elements = (0, _utils.mergeElements)([pagesRef, customMatchesRef]);
    if (event.key === 'ArrowDown' && elements.length > 0) {
      event.preventDefault();
      elements.at(0).focus();
    }
    if (event.key === 'ArrowUp' && elements.length > 0) {
      event.preventDefault();
      elements.at(-1).focus();
    }
  }, []);
  (0, _hooks.useShortcut)('cmd+g', handleNextMatchShortcut);
  (0, _hooks.useShortcut)('cmd+shift+g', handlePrevMatchShortcut);
  var handleResultsKeyDown = (0, _utils.useArrowHandling)([pagesRef, customMatchesRef], [pageMatches]);
  if (disabled) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement(_SearchContext.AssetPortalSearchContext.Provider, {
    value: searchContextValue
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: styles.searchSection,
    "data-test-id": "search-component"
  }, /*#__PURE__*/_react.default.createElement(_TextField.default, {
    className: styles.textfield,
    autoFocus: true,
    setRef: setInputRef,
    autoComplete: "off",
    testId: "portal-search",
    id: "portal-search",
    name: "portal-search",
    type: "text",
    onChange: handleChange,
    onKeyDown: handleTextFieldKeyDown,
    value: term,
    placeholder: "Search content",
    maxLength: SEARCH_MAX_LENGTH
  }), /*#__PURE__*/_react.default.createElement(_Actions.default, {
    onPrevMatch: handlePrevMatch,
    onNextMatch: handleNextMatch,
    onClose: onClose
  })), loading ? /*#__PURE__*/_react.default.createElement("div", {
    className: styles.spinner
  }, /*#__PURE__*/_react.default.createElement(_Spinner.default, {
    size: "s"
  })) : null, !emptyResults ? /*#__PURE__*/_react.default.createElement("div", {
    className: styles.results
  }, pageMatches.length ? /*#__PURE__*/_react.default.createElement("div", {
    className: styles.section
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: styles.sectionTitle
  }, "Pages"), /*#__PURE__*/_react.default.createElement(_Pages.default, {
    groupId: asset.groupId,
    assetId: asset.assetId,
    version: asset.version,
    pages: pageMatches,
    ref: pagesRef,
    onKeyDown: handleResultsKeyDown
  })) : null, customMatches.length ? /*#__PURE__*/_react.default.createElement("div", {
    className: styles.section
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: styles.sectionTitle
  }, searchConfiguration === null || searchConfiguration === void 0 ? void 0 : searchConfiguration.sectionName), /*#__PURE__*/_react.default.createElement(_CustomResults.default, {
    matches: customMatches,
    ref: customMatchesRef,
    onKeyDown: handleResultsKeyDown
  })) : null) : null, emptyResults ? /*#__PURE__*/_react.default.createElement("div", {
    className: styles.emptyResults
  }, "No results found") : null);
});
var _default = exports.default = Search;
//# sourceMappingURL=Search.js.map